// 优化的跟踪脚本 - 合并所有跟踪功能
(function() {
    'use strict';
    
    // 初始化所有跟踪
    function initTracking() {
        // Clarity跟踪
        (function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "k23ls2z0ac");

        // Hotjar跟踪
        (function(h,o,t,j,a,r){
            h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
            h._hjSettings={hjid:6484472,hjsv:6};
            a=o.getElementsByTagName('head')[0];
            r=o.createElement('script');r.async=1;
            r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
            a.appendChild(r);
        })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');

        // Reddit跟踪
        if(!window.rdt){
            var p=window.rdt=function(){
                p.sendEvent ? p.sendEvent.apply(p,arguments) : p.callQueue.push(arguments)
            };
            p.callQueue=[];
            var t=document.createElement("script");
            t.src="https://www.redditstatic.com/ads/pixel.js",t.async=!0;
            var s=document.getElementsByTagName("script")[0];
            s.parentNode.insertBefore(t,s)
        }
        window.rdt('init','a2_fqssgplframd', {"optOut": false,"useDecimalCurrencyValues":true});
    }

    // 简化的Reddit事件跟踪
    function setupRedditTracking() {
        if (typeof window.rdt !== 'function') return;
        
        // 产品查看
        if (document.body.classList.contains('template-product') || window.location.pathname.includes('/products/')) {
            const productData = getProductData();
            if (productData) {
                window.rdt('track', 'ViewContent', {
                    products: {id: productData.id, category: productData.type, name: productData.title},
                    language: document.documentElement.lang || 'en'
                });
            }
        }
        
        // 添加到购物车
        document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
            form.addEventListener('submit', function() {
                const productData = getProductData();
                if (productData) {
                    window.rdt('track', 'AddToCart', {
                        currency: 'USD', value: productData.price,
                        products: {id: productData.id, category: productData.type, name: productData.title}
                    });
                }
            });
        });
        
        // 结账
        document.querySelectorAll('[data-action="checkout"], .btn-checkout').forEach(button => {
            button.addEventListener('click', function() {
                window.rdt('track', 'InitiateCheckout', {currency: 'USD'});
            });
        });
    }

    // 获取产品数据
    function getProductData() {
        const productJson = document.querySelector('script[type="application/json"][id*="product-json"]');
        if (productJson) {
            try { return JSON.parse(productJson.textContent); } catch(e) { return null; }
        }
        
        const productTitle = document.querySelector('h1, .product-title');
        if (productTitle) {
            return {
                id: window.location.pathname.split('/products/')[1]?.split('?')[0] || 'unknown',
                title: productTitle.textContent.trim(),
                type: 'product',
                price: 0
            };
        }
        return null;
    }

    // 页面加载完成后初始化
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            initTracking();
            setupRedditTracking();
        });
    } else {
        initTracking();
        setupRedditTracking();
    }
})();
